import styles from './Table.module.css';

export const TableCellPlaceholder = () => (
  <div className={styles.cellPlaceholder}>
    <div />
  </div>
);
